export const DeviceIsMobile = () => {
  return window.innerHeight <= 500 || window.innerWidth <= 750;
}
